import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity10 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_10;
}

export default DirtRoadTileEntity10;
